// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__CQRIz","bigColWidth":"Table_bigColWidth__97gre","biggerColWidth":"Table_biggerColWidth__27zXm","row":"Table_row__15Z3T","col":"Table_col__2RaDk"};